import React from "react";
import Login from "../../components/login/Login";

class LoginContainer extends React.Component {
  handleSubmit = (values) => {
    this.props.login(values);
  };
  handleClickShowPassword = (is_show) => {
    this.props.setShowPassword(is_show)
  }
  componentWillUnmount(){
    this.props.setResetState();
  }
  render() {
    const {is_loading,show_password,company_details} = this.props
    return (
      <Login
      login = {this.handleSubmit}
      is_loading = {is_loading}
      show_password = {show_password}
      handleClickShowPassword = {this.handleClickShowPassword}
      company_details = {company_details}
      />
    );
  }
}

export default LoginContainer;
